import { useCallback } from 'react'

import { eventLogsService } from '../../api'
import { ActivityLogCard } from '../event-logs/activity-log-card'

export function OrderActivityLog({ orderId }: { orderId: string }) {
  const fetchEvents = useCallback(
    () => eventLogsService.getEventLogsByOrder(orderId, { limit: '100' }),
    [orderId],
  )

  return (
    <ActivityLogCard
      title="Order Activity"
      emptyMessage="No activity recorded for this order"
      columns={['time', 'level', 'event', 'message', 'details', 'actor']}
      fetchEvents={fetchEvents}
    />
  )
}
